export default __webpack_public_path__ + "static/media/propic1.2e4ef16d.png";